
export default {
  name: 'OnboardingThumbIcon',
};
